import { useState } from "react";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import Link from "next/link";
import { gql, useQuery } from "@apollo/client";

import { ScheduleLegend } from "@/components/schedule";
import "@/styles/Schedule.module.scss";
import PageHeader from "@/components/PageHeader";
import Seo from "@/components/seo";
import handleStaticProps from "src/lib/handle-static-props";

const Calendar = dynamic(() => import("@/components/schedule/Calendar"), {
  ssr: false,
});

export async function getStaticProps() {
  const { result } = await handleStaticProps({
    pageQuery,
  });
  return result;
}

function Schedule() {
  const { data } = useQuery(pageQuery);
  const router = useRouter();
  const [selectedDate, setSelectedDate] = useState();

  const handleShowClick = (show) => {
    router.push(show);
  };
  const handleSelect = (e) => {
    const scheduleBlock = data.allScheduleBlocks[e.target.value];
    setSelectedDate(scheduleBlock.start);
  };

  return (
    <div className="container">
      <Seo title="Programming Schedule" />
      <PageHeader>Programming Schedule</PageHeader>
      <div className="row">
        <div className="col-lg-2 order-lg-2">
          <ScheduleLegend />
        </div>
        <div id="calendar" className="col-lg-10 order-lg-1">
          <p>
            Go to a specific a semester! Schedule may take some time to load.
          </p>
          <select name="show" className="form-control" onChange={handleSelect}>
            <option value="-1" disabled>
              -------
            </option>
            {data.allScheduleBlocks.map(({ id, name }, i) => (
              <option value={i} key={id}>
                {name}
              </option>
            ))}
          </select>
          <Calendar
            handleShowClick={handleShowClick}
            selectedDate={selectedDate}
          />
        </div>
      </div>
      <p className="text-center">
        <Link href="/history/">
          Looking for a past song? Check out the history.
        </Link>
      </p>
    </div>
  );
}

export default Schedule;

const pageQuery = gql`
  query GetAllScheduleBlocks {
    allScheduleBlocks {
      id
      name
      start
      end
    }
  }
`;
